import { schema } from 'normalizr';

export const ENTITY_REDUCER_KEY = 'accounts';
export const ENTITY_CONTEXT_ID_KEY = 'accountId';

export const entity = new schema.Entity(ENTITY_REDUCER_KEY);
export const entities = new schema.Array(entity);
